Revolution.Module.extend({
    NAME: "mde.sliders", // OBLIGATOIRE (reflète l'arborescence répertoire : /mde/main.js)
    slider3ColumnsIsInit : false,
    sliders3Columns : [],
    slider4ColumnsIsInit : false,
    sliders4Columns : [],

    initialize: function ($) {
        // appelé aussitôt la page chargée
        //console.log("module " + this.NAME);

        _.bindAll(this, "onWindowResize", "initSlider3Columns", "initOrDestroySlidersColumns");

        //events

        this.initSliders();

        this.initOrDestroySlidersColumns();
    },

    onWindowLoad: function (e) {

    },

    onWindowScroll: function (e) {

    },
    onWindowResize: function (e) {
        this.initOrDestroySlidersColumns();
    },

    initSlider3Columns : function () {
        $('.js-slider-3-columns').each(_.bind(function (index, elem) {
            var slider3cols = new Swiper($(elem).find('.swiper-container'), {
                slidesPerView: 1,
                spaceBetween: 15,
                slideToClickedSlide: false,
                breakpoints: {
                    767: {
                        slidesPerView: 2
                    },
                    1023: {
                        slidesPerView: 3
                    },
                }
            });

            this.sliders3Columns.push(slider3cols);
        }, this));
    },

    initSlider4Columns : function () {
        $('.js-slider-4-columns').each(_.bind(function (index, elem) {
            var slider4cols = new Swiper($(elem).find('.swiper-container'), {
                slidesPerView: 1,
                spaceBetween: 15,
                slideToClickedSlide: false,
                breakpoints: {
                    767: {
                        slidesPerView: 2
                    },
                    1023: {
                        slidesPerView: 3
                    },
                }
            });

            this.sliders4Columns.push(slider4cols);
        }, this));
    },

	initOrDestroySlidersColumns : function () {
        if($('.js-slider-3-columns').length) {
            if ($(window).width() < 1024) {
                if (!this.slider3ColumnsIsInit) {
                    this.initSlider3Columns();
                    this.slider3ColumnsIsInit = true;

                }
            } else {
                if (this.slider3ColumnsIsInit) {
                    $.each(this.sliders3Columns, function( index, elmt ) {
                        elmt.destroy();
                    });
                    this.sliders3Columns = [];
                    this.slider3ColumnsIsInit = false;
                }
            }

            $('.js-slider-3-columns').attr('data-init-swiper', this.slider3ColumnsIsInit);
            $.fn.matchHeight._apply($('.js-slider-3-columns').find('.article-content'));
            $.fn.matchHeight._apply($('.js-slider-3-columns').find('.mea-content'));
            $.fn.matchHeight._apply($('.js-slider-3-columns').find('.agenda-top'));
            $.fn.matchHeight._apply($('.js-slider-3-columns').find('.agenda-content'));
            window.bLazy.load($('.js-slider-3-columns').find('.lazy'));
        }

        if($('.js-slider-4-columns').length) {
            if ($(window).width() < 1280) {
                if (!this.slider4ColumnsIsInit) {
                    this.initSlider4Columns();
                    this.slider4ColumnsIsInit = true;

                }
            } else {
                if (this.slider4ColumnsIsInit) {
                    $.each(this.sliders4Columns, function( index, elmt ) {
                        elmt.destroy();
                    });
                    this.sliders4Columns = [];
                    this.slider4ColumnsIsInit = false;
                }
            }

            $('.js-slider-4-columns').attr('data-init-swiper', this.slider4ColumnsIsInit);
            $.fn.matchHeight._apply($('.js-slider-4-columns').find('.article-content'));
            $.fn.matchHeight._apply($('.js-slider-4-columns').find('.mea-content'));
            $.fn.matchHeight._apply($('.js-slider-4-columns').find('.agenda-top'));
            $.fn.matchHeight._apply($('.js-slider-4-columns').find('.agenda-content'));
            window.bLazy.load($('.js-slider-4-columns').find('.lazy'));
        }
    },

    initSliders: function () {
        $('.js-slider-carousel').each(function (index, elem) {
            var swiperCarousel = new Swiper($(elem).find('.swiper-container'), {
                slidesPerView: 3,
                spaceBetween: 25,
                centeredSlides: true,
                loop: true,

                breakpoints: {
                    1024: {
                        slidesPerView: 3,
                        spaceBetween: 25,
                    },
                    320: {
                        slidesPerView: 1,
                        spaceBetween: 5,
                    }
                },

                navigation: {
                    nextEl: $(elem).find('.swiper-button-next'),
                    prevEl: $(elem).find('.swiper-button-prev'),
                },

                on: {
                    slideChange: function () {
                        $(swiperCarousel.slides[swiperCarousel.previousIndex]).removeClass('bigger');
                        $(swiperCarousel.slides[swiperCarousel.previousIndex]).removeClass('-transition');

                        $(swiperCarousel.slides[swiperCarousel.activeIndex]).addClass('bigger');
                        $(swiperCarousel.slides[swiperCarousel.activeIndex]).addClass('-transition');
                    }
                }
            });

            window.bLazy.load($(elem).find('.lazy'));
            setTimeout(function () {
                $.fn.matchHeight._apply($(elem).find('.article-content'));
                $.fn.matchHeight._apply($(elem).find('.agenda-top'))
            }, 800);
            setTimeout(function () {
                $(elem).find('.swiper-slide-active').addClass('bigger');
            }, 1000);
        });

        $('.js-slider-images').each(function (index, elem) {
            var swiperImages = new Swiper($(elem).find('.swiper-container'), {
                slidesPerView: 1,
                centeredSlides: true,
                loop: true,
                updateOnImagesReady: true,
                pagination: {
                    el: $(elem).find('.swiper-pagination'),
                    type: 'fraction',
                },
                navigation: {
                    nextEl: $(elem).find('.swiper-button-next'),
                    prevEl: $(elem).find('.swiper-button-prev'),
                },
                on: {
                    imagesReady: function () {
                        setTimeout(_.bind(function () {
                            $(this.el).find('[class*="swiper-button"]').css('top', $(this.el).find('.swiper-slide-active img').height() + 'px');
                        }, this), 200);
                    },
                    resize: function () {
                        $(this.el).find('[class*="swiper-button"]').css('top', $(this.el).find('.swiper-slide-active img').height() + 'px');
                    },
                }
            });

            window.bLazy.load($(elem).find('.lazy'));
        });
    }

});
